<script>
  const faq = [
    {
      q: "Does TGE Max have access to Gextron & other custom software?",
      a: "Yes! TGE Max members get full access to Gextron and future custom trading software, designed to enhance decision-making and optimize trades.",
    },
    {
      q: "What does the plan or path forward look like if you sign up?",
      a: "Once you join, you get instant access to our private Telegram group and Gextron software. We start with a 1-on-1 call to assess your trading level and create a customized roadmap for your growth. <br /><br />You'll also shadow my real-time trades—seeing the reasoning, execution, and strategy behind each move. Plus, you get unlimited 1-on-1 support calls to answer any questions about trade setups, market conditions, or anything else you need.",
    },
    {
      q: "How much time do you need to dedicate over the next 90 days?",
      a: "Most members dedicate 5-7 hours per week, but it's flexible. Focused sessions in the evenings or weekends work best, especially for those balancing a full-time job.",
    },
    {
      q: "How quickly will you see returns that pay back the investment?",
      a: "Results vary, but most members start seeing consistent positive returns within 2-3 months as they refine execution and apply what they learn. Success depends on commitment, strategy, and discipline.",
    },
  ];
</script>

<div class="faq">
  <div class="container">
    <div class="inner-container">
      <div class="faq-container">
        <div class="faq-questions">
          <h2 class="h1">Frequently asked questions</h2>
          <div class="faq-list">
            {#each faq as item}
              <div class="faq-list-item">
                <div>
                  <div class="faq-title">{item.q}</div>
                  <p class="faq-a">{@html item.a}</p>
                </div>
              </div>
            {/each}
          </div>
        </div>
        <div class="booking-card">
          <div class="booking-card-inner">
            <img src="/imgs/me.jpg" loading="lazy" />
            <div class="booking-card-title">Book a 15-min intro call</div>
            <a href="#booking" class="button">Book a call</a>
          </div>
          <a href="mailto:ruben@alfatoro.com" class="hero-booking-call">
            <div class="email-detail-container">
              <span class="send-icon"
                ><svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-send"
                  ><path
                    d="M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z"
                  /><path d="m21.854 2.147-10.94 10.939" /></svg
                ></span
              >
              <div class="email-details">
                <div>Prefer to email?</div>
                <div>ruben@alfatoro.com</div>
              </div>
            </div>
            <span class="booking-svg-container">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-move-right"
                ><path d="M18 8L22 12L18 16" /><path d="M2 12H22" /></svg
              >
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .faq {
    padding: 0 5%;
    background-color: #ece6e8;
  }

  .faq h2 {
    color: #000;
  }

  .faq-container {
    display: flex;
    align-items: center;
    gap: 32px;
    justify-content: center;
    flex-direction: column;
  }

  .faq-questions {
    flex: 1;
    max-width: 590px;
  }

  .faq-list {
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-top: 35px;
  }

  .faq-list-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 32px;
    color: #000;
  }

  .faq-title {
    font-size: 20px;
    font-weight: 500;
    line-height: 110%;
  }

  .faq-a {
    color: #99948f;
    margin-top: 12px;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 20px;
  }

  .booking-card {
    border-radius: 20px;
    padding: 32px;
    box-shadow: 0 50px 50px #0003;
    background-color: #000;
  }

  .booking-card img {
    width: 130px;
    margin-bottom: 24px;
    border-radius: 50%;
  }

  .booking-card-title {
    font-size: 40px;
    font-weight: 500;
    line-height: 100%;
  }

  .hero-booking-call {
    justify-content: space-between;
    margin-top: 32px;
    display: flex;
    align-items: center;
    color: #fff;
  }

  .booking-card-inner .button {
    background-color: #fff;
    color: #000;
  }

  .hero-booking-call .email-details > div:last-child {
    color: #d5d5d587;
  }

  .booking-svg-container {
    height: 34px;
    width: 34px;
    border-radius: 50%;
    background-color: #fff;
    color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .send-icon {
    display: inline-flex;
    height: 30px;
    width: 30px;
  }

  .send-icon svg {
    height: 30px;
    width: 30px;
  }

  .email-detail-container {
    gap: 12px;
    justify-content: flex-start;
    align-items: center;
    display: flex;
  }

  @media screen and (min-width: 1024px) {
    .faq-container {
      flex-direction: initial;
      justify-content: space-between;
      align-items: flex-start;
    }

    .booking-card {
      max-width: 390px;
    }
  }
</style>
